import React from 'react';
import styled from 'styled-components';
import { Flex, Box } from '@rebass/grid';
import { IconSuitcases } from '@amtrav/icons';
import { media } from '@amtrav/themes';
import { getTokenValue } from '@amtrav/theme-system';

const MessageText = styled(Box)`
  width: 100%;
  font-size: 20px;
  text-align: center;
  line-height: 1.4;

  ${media.Medium`
    width: 407px;
  `};
`;

const Suitcases = styled(Box)`
  width: 134px;
  height: 134px;
  font-size: 134px;
`;

const SuccessContainer = styled(Flex)`
  height: 335px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

const AccountSetupSuccess = () => {
  return (
    <SuccessContainer>
      <MessageText>
        <strong>Please check your mail.</strong>
      </MessageText>
      <MessageText>
        We have sent you a message to confirm your email address. Please check your inbox and click the confirmation
        link provided.
      </MessageText>
      <Suitcases>
        <IconSuitcases />
      </Suitcases>
    </SuccessContainer>
  );
};

export default AccountSetupSuccess;
